import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, AfterViewChecked, OnChanges } from '@angular/core';

declare var jQuery: any;

@Component({
  selector: 'ch-select-picker',
  templateUrl: './select-picker.component.html',
  styleUrls: ['./select-picker.component.css'],
})
export class SelectPickerComponent implements AfterViewInit, AfterViewChecked, OnChanges {
  @Input() public value: string;
  @Input() public items: Array<any> = [];
  @Input() public showClass: boolean;
  @Output() public change: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('select') public select: ElementRef;
  private sync: boolean;

  ngAfterViewInit() {
    this.syncSelectPicker();
  }

  ngAfterViewChecked() {
    if (this.sync) {
      this.syncSelectPicker();
    }
  }

  ngOnChanges(data) {
    if (data) {
      this.sync = true;
    }
  }

  private syncSelectPicker() {
    if ('undefined' === typeof jQuery) {
      return;
    }

    jQuery(this.select.nativeElement)['selectpicker']('refresh');
    this.sync = false;
  }

  public itemSelected(event) {
    this.change.emit(event);
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/core/widgets/select-picker/select-picker.component.ts